<template>
  <nuxt-link :to="href" :class="{ plain, white }">
    <slot />
  </nuxt-link>
</template>

<script setup lang="ts">
import { isAbsolutePath } from '~/helpers/routing';

const props = defineProps<{
  to: string;
  plain?: boolean;
  white?: boolean;
}>();

const { toAbsolute } = useRouting();

const originAbsolute = isAbsolutePath(props.to);
const href = ref(toAbsolute(props.to));

onMounted(() => {
  if (!originAbsolute) setAsRelative();
});

function setAsRelative() {
  href.value = props.to;
}
</script>